module.exports = __webpack_public_path__ + "static/media/balance-group-lesson.bd0ef799.jpg";